import PropTypes from 'prop-types';
import React from 'react';
import { 
  ProfileSectionWrapper, 
  TitleWrapper, 
  ProfileDescription,
  Profile,
  ProfileTitle,
  ProfileImage,
  ProfileContent,
  ProfileName,
  ProfileNameEn,
} from './ProfileSection.style';
import Markdown from '../../../components/Markdown';

const ProfileSection = ({ data }) => (
  <ProfileSectionWrapper>
    <TitleWrapper>{data.title}</TitleWrapper>
    {data.profiles.map(profile => (
      <Profile key={profile.entryId}>
        <ProfileImage>
          <img src={profile.image.file.url} alt={profile.image.title} />
        </ProfileImage>
        <ProfileContent>
          <ProfileTitle>{profile.title}</ProfileTitle>
          <ProfileNameEn>{profile.nameEn}</ProfileNameEn>
          <ProfileName>{profile.name}</ProfileName>
          <Markdown src={profile.description} Component={ProfileDescription}></Markdown>
        </ProfileContent>
      </Profile>
    ))}
  </ProfileSectionWrapper>
);

ProfileSection.defaultProps = {
  data: {},
};
ProfileSection.propTypes = {
  data: PropTypes.shape(),
};

export default ProfileSection;



// WEBPACK FOOTER //
// ./src/pages/RangePage/ProfileSection/ProfileSection.js